import React from "react";

export interface IGlobalLoaderContext {
  isActiveLoader: boolean;

  setLoader(active: boolean): void;
}

export const GlobalLoaderContext = React.createContext<IGlobalLoaderContext>({
    isActiveLoader: false,
    setLoader(active: boolean) {
      return
    }
  }
)
